export const COMPARISON_DATA = {
  Jotform: {
    slug: 'jotform',
    title: 'WebForms.biz vs Jotform | Compare Form Builders',
    description: 'Compare WebForms.biz with Jotform by workflow, publishing options, optimization tools, transparent plan limits, and migration effort.',
    intro: 'Move from Jotform with a clear inventory of your forms, connected tools, and response workflows before you rebuild.',
    migration: [
      'Inventory every Jotform form, field, conditional rule, notification, payment step, and embed location.',
      'Recreate the form structure in WebForms.biz, then map Jotform logic to conditional fields and multi-step flows.',
      'Reconnect notifications and downstream tools with Zapier, webhooks, or API access where your plan includes it.',
      'Run test submissions against required fields, payment behavior, emails, analytics, and response exports.',
      'Publish the new form beside the old one for a controlled check, then switch traffic and keep a rollback copy.',
    ],
  },
  Typeform: {
    slug: 'typeform',
    title: 'WebForms.biz vs Typeform | Compare Form Builders',
    description: 'Compare WebForms.biz with Typeform by workflow, publishing options, optimization tools, transparent plan limits, and migration effort.',
    intro: 'Bring Typeform-style conversational experiences into a broader form workspace with a deliberate, testable migration plan.',
    migration: [
      'List each Typeform form, question sequence, branching rule, welcome/end screen, integration, and live embed.',
      'Rebuild the question flow with WebForms.biz multi-step or conversational form flows and match the respondent journey.',
      'Reconnect analytics, notifications, payments, and other destinations through the integrations available on your plan.',
      'Submit representative answers on desktop and mobile to validate logic, styling, tracking, and exports.',
      'Publish the replacement using a share link or embed, monitor the first responses, and keep the original available for rollback.',
    ],
  },
  Paperform: {
    slug: 'paperform',
    title: 'WebForms.biz vs Paperform | Compare Form Builders',
    description: 'Compare WebForms.biz with Paperform by workflow, publishing options, optimization tools, transparent plan limits, and migration effort.',
    intro: 'Plan a Paperform migration around the content, calculations, payments, and embeds your team relies on today.',
    migration: [
      'Inventory every Paperform form, content block, calculation, conditional rule, payment setting, integration, and embed.',
      'Recreate the fields and content in WebForms.biz, then translate calculations and conditional paths into supported form logic.',
      'Reconnect payment and workflow destinations using Stripe, Zapier, webhooks, or API access where available.',
      'Test calculations, required fields, confirmation screens, styling, mobile behavior, and response exports with sample data.',
      'Release the new form in a controlled changeover, confirm the first live submission, and retain a rollback checklist.',
    ],
  },
  Tally: {
    slug: 'tally',
    title: 'WebForms.biz vs Tally | Compare Form Builders',
    description: 'Compare WebForms.biz with Tally by workflow, publishing options, optimization tools, transparent plan limits, and migration effort.',
    intro: 'Compare Tally’s lightweight form experience with a broader workspace for publishing, responses, analytics, payments, and team workflows.',
    migration: [
      'Inventory each Tally form, question, logic rule, notification, integration, and embed location.',
      'Recreate the form structure in WebForms.biz and map Tally logic to supported conditional fields and multi-step flows.',
      'Reconnect downstream workflows with the integrations available on your WebForms.biz plan, including webhooks or API access where applicable.',
      'Run representative test submissions to validate required fields, styling, payment behavior, analytics, notifications, and exports.',
      'Publish the replacement in a controlled changeover, monitor the first live responses, and keep the original available for rollback.',
    ],
  },
};

export const getComparisonPageByPath = (pathname = '') => {
  const normalizedPath = pathname.split('?')[0].replace(/\/+$/, '');
  return Object.values(COMPARISON_DATA).find((page) => normalizedPath === `/vs/${page.slug}`) || null;
};